angular
    .module("skillBuilderSaaS")
    .directive("uibTimepicker", (["uibDateParser", function (uibDateParser) {
        return {
            require: "ngModel",
            link: function (_scope, _element, _attrs, ngModel) {
                ngModel.$formatters.push(function (value) {
                    if (!value) {
                        return value;
                    }
                    return uibDateParser.fromTimezone(value, "UTC");
                });
                //ngModel.$parsers.push((value) => { // model
                //	if (!value) { return value; }
                //	return uibDateParser.toTimezone(value, "UTC");
                //});
            }
        };
    }]));
